/**
 * 设备管理-校牌管理
 */
import request from '@/utils/request';
import { getToken } from '@/utils/auth';
import ENVIRONMENT from '@/utils/environment';

/**
 * 根据机构code获取校牌列表
 */
export function getSchoolCardList(searchForm) {
  return request({
    url: `/op/devices/school-cards/list`,
    method: 'get',
    params: searchForm
  });
}

/**
 * 校牌绑定
 * @param {*} form
 */
export function bindStudentCard(studentCode, imei) {
  return request({
    url: `/op/devices/student-bind-card`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: { studentCode, imei }
  });
}

/**
 * 校牌解绑
 * @param {*} form
 */
export function unbindStudentCard(studentCode) {
  return request({
    url: `/op/devices/unlock-student-bind-card`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: { studentCode }
  });
}

/**
 * 查询校牌详情
 */
export function getSchoolCardDetail(schoolCode, imei) {
  return request({
    url: `/op/devices/detail/${imei}`,
    method: 'get',
    params: { schoolCode }
  });
}

/**
 * 班级学生【或某个学生】的最新位置
 */
export function getStudentPosition(classCode, studentCodes) {
  return request({
    url: `/op/devices/gis/class-gis`,
    method: 'get',
    params: { classCode, studentCodes }
  });
}

/**
 * 某个学生的当日的轨迹
 */
export function getStudentTrajectory(studentCode) {
  return request({
    url: `/op/devices/gis/date-gis`,
    method: 'get',
    params: { studentCode }
  });
}

/**
 *    校牌导出
 */
export function DownloadSchoolCardDetailUrl(schoolCode, stype) {
  return `${ENVIRONMENT.BASE_API}/op/devices/excel?token=${getToken()}&schoolCode=${schoolCode}&stype=${stype}`;
}

/**
 * 设备解禁/禁用规则新增
 * @param {*} form
 */
export function addDisableSettings(from) {
  return request({
    url: `/op/abledevicerule/`,
    method: 'post',
    data: { ...from, custom: true }
  });
}

/**
 * 设备解禁/禁用规则编辑
 * @param {*} form
 */
export function editDisableSettings(id, form) {
  return request({
    url: `/op/abledevicerule/${id}`,
    method: 'post',
    data: { ...form, custom: true }
  });
}

/**
 * 设备解禁/禁用规则查询详情
 */
export function getDisableSettingsDetail(id) {
  return request({
    url: `/op/abledevicerule/${id}`,
    method: 'get'
  });
}

/**
 * 设备解禁/禁用规则查询列表
 */
export function getDisableSettingsList(searchForm) {
  return request({
    url: `/op/abledevicerule/list`,
    method: 'get',
    params: searchForm
  });
}

/**
 * 设备解禁/禁用规则删除
 * @param {*} form
 */
export function deleteDisableSettings(id) {
  return request({
    url: `/op/abledevicerule/${id}`,
    method: 'delete'
  });
}

/**
 * 设备解禁/禁用规则启/禁用
 * @param {*} form
 */
export function enableDisableSettings(id, status) {
  return request({
    url: `/op/abledevicerule/enable/${id}`,
    method: 'post',
    params: { status },
    data: { custom: true }
  });
}

/**
 * 查看校牌日志
 */
export function schoolCardLogs(options) {
  return request({
    url: `/op/devices/query/school-card/command-logs`,
    method: 'get',
    params: options
  });
}
/**
 *更换设备
 */
export function replaceSchoolCard(options) {
  return request({
    url: `/op/devices/replaceSchoolCard`,
    method: 'post',
    data: options,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}
/**
 *查询日志指令
 */
export function getLogCommand(options) {
  return request({
    url: `/op/devices/getLogCommand`,
    method: 'get',
    params: options
  });
}
/**
 *导出日志列表
 */
export function exportLogLiSTExcel(options) {
  return `${ENVIRONMENT.BASE_API}/op/devices/exportLogLiSTExcel?token=${getToken()}&imei=${options.imei}&toTime=${options.toTime}&endTime=${options.endTime}&command=${options.command}`;
}

/**
 *查询社区绑定设备分页列表
 */
export function getBindDevicesPage(options) {
  return request({
    url: `/community/bind/devices/page`,
    method: 'get',
    params: options
  });
}
